<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.90039 8L6.90039 24H24.9004L22.9004 8" stroke="black" stroke-width="2" stroke-linejoin="bevel"/>
    <path d="M18.8999 8.4C18.8999 10.0569 17.5568 11.4 15.8999 11.4C14.243 11.4 12.8999 10.0569 12.8999 8.4" stroke="black" stroke-width="2" stroke-linejoin="bevel"/>
  </svg>
  <div v-if="quantity > 0" class="relative top-2 right-4 rounded-full w-5 h-5 bg-black text-white text-xs flex justify-center align-middle items-center">{{ quantity }}</div>
</template>

<script setup lang="ts">

import {useCartStore} from "~/store/cart";

const { quantity } = storeToRefs(useCartStore())

</script>